import { BudgetService } from '@/services/BudgetService';
import { TransactionService } from '@/services/TransactionService';
import type { Budget, Transaction } from '@/types';

export interface UserDataExport {
  exportedAt: string;
  app: string;
  version: string;
  budgets: Budget[];
  transactions: Transaction[];
}

/**
 * Build a JSON export of the user's budgets and transactions
 * from data available to the logged-in client.
 */
export async function buildUserDataExport(userId: string): Promise<UserDataExport> {
  const budgets = await BudgetService.getAll(userId);
  const transactionLists = await Promise.all(
    budgets.map((budget) => TransactionService.getByBudget(budget.id))
  );
  const transactions = transactionLists.flat();

  return {
    exportedAt: new Date().toISOString(),
    app: 'My Budget',
    version: '1.0.0',
    budgets,
    transactions,
  };
}

export function downloadJsonExport(data: UserDataExport, filename?: string): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  const stamp = data.exportedAt.slice(0, 10);
  anchor.href = url;
  anchor.download = filename ?? `my-budget-export-${stamp}.json`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
